export default __webpack_public_path__ + "static/media/create-trustline-step-4@3x.384b2ff8.png";